import React from "react";
import {
  Box,
  Button,
  Container,
  HStack,
  Icon,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import V2SelectorContainer from "containers/V2SelectorContainer";
import V2Image from "components/V2Image";
import { Link } from "react-router-dom";
import { FaChevronLeft, FaExternalLinkAlt } from "react-icons/fa";
import StakedTraitsContainer from "containers/StakedTraitsContainer";
import V2Provider from "providers/V2Provider";
import V2Context from "contexts/V2Context";
import V2AttributesContainer from "containers/V2AttributesContainer";
import { v2Contract, openSeaAssetBaseUrl, featureFlags } from "config";
import Panel from "components/Panel";

const NftPage: React.FC = () => (
  <V2Provider>
    <Container pt="12" pb="16">
      <VStack spacing="3" align="flex-start">
        <Box w="full">
          <Panel borderRadius="none" borderTopRadius="md">
            <VStack spacing="3">
              <V2Context.Consumer>
                {({ tokenId }) => (
                  <>
                    <HStack justify="space-between" w="full">
                      <HStack spacing="1.5" justify="center">
                        <Link to="/nfts" style={{ lineHeight: "0" }}>
                          <IconButton
                            icon={<Icon as={FaChevronLeft} w="5" h="auto" />}
                            variant="link"
                            aria-label=""
                            size="sm"
                          />
                        </Link>

                        <V2SelectorContainer basePath="/nfts" />
                      </HStack>

                      <Button
                        as="a"
                        href={`${openSeaAssetBaseUrl}/${v2Contract.address}/${tokenId}`}
                        target="_blank"
                        rel="noreferrer"
                        flexShrink="0"
                        size="sm"
                        cursor="pointer"
                        colorScheme="dark"
                        variant="outline"
                        rightIcon={<Icon as={FaExternalLinkAlt} />}
                      >
                        OpenSea
                      </Button>
                    </HStack>

                    <V2Image tokenId={tokenId!} size="full" />
                  </>
                )}
              </V2Context.Consumer>
            </VStack>
          </Panel>

          <V2AttributesContainer />
        </Box>

        {featureFlags.traitsSwapping && <StakedTraitsContainer />}
      </VStack>
    </Container>
  </V2Provider>
);

export default NftPage;
